import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { slot: "content" }
const _hoisted_7 = { slot: "content" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { slot: "content" }
const _hoisted_11 = { slot: "content" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 1,
  class: "ion-padding"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "table-container" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "large-text" }
const _hoisted_23 = { class: "large-text" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "table-container" }
const _hoisted_26 = ["src", "onClick"]

import { add, remove } from 'ionicons/icons';

// Vue reactivity
import { ref, defineComponent, computed, watch, reactive, onMounted } from 'vue';

// icons
import { close, arrowBack, checkmarkCircle, alertCircle, ellipsisHorizontal, ellipsisVertical, } from 'ionicons/icons';

// components
import { IonHeader, IonToolbar, IonTitle, IonContent, IonFooter, IonRow, IonCol,
        IonItem, IonLabel, IonIcon, IonButtons, IonButton, IonSpinner, IonList,
        IonCard, IonCardHeader, IonCardSubtitle, IonCardContent, IonPopover,
        IonAccordion, IonAccordionGroup, IonText, IonSegment, IonSegmentButton, IonChip,
        loadingController, modalController, alertController, } from '@ionic/vue';
import SessionStudentListModal from '@/components/modals/SessionStudentListModal.vue';
import SLPModal from '@/components/secondary/ABSLPModal.vue';
import UniEventsDetails from '@/components/client/UniEventsDetails.vue'
import ServiceModal from '@/components/modals/ServiceModal.vue';
import ActionAccordionGroup from '@/components/shared/ActionAccordionGroup.vue';

// composables / services
import { useI18n } from 'vue-i18n';
import { utils } from '@/composables/utils';
import { useStore } from '@/store';
import CommonService from '@/services/CommonService';

// Map
import { Loader } from '@googlemaps/js-api-loader';

// methods or filters

export default /*@__PURE__*/_defineComponent({
  __name: 'ClientActionCardList',
  setup(__props) {

// Icons
const store = useStore();
const { t } = useI18n();
const { openModal, formatDate, openImageModal, getProxyImgLink, closeModal, } = utils();

//const loadingData = computed(() => store.state.loadingUser || store.state.loadingData || store.state.loadingSchoolUserData);
const loadingData = computed(() => store.state.loadingUser || store.state.loadingData);
const user = computed(() => store.state.user);
const userRelatedClient = computed(() => store.getters.userRelatedClient);
const clientHomeSlideImgUrl = ref(null);
const clientServices = computed(() => store.getters.getSecSchoolServicesByClientId(user.value.clientId || "c955c4b06"));
const clientUniSessions = computed(() => store.getters.getUniEventSessionsByClientId(user.value.clientId || "c955c4b06"));
const clientUniServices = computed(() => store.getters.getUniServicesByClientId(user.value.clientId || "c955c4b06"));

const clientSessions = computed(() => store.getters.getSessionsByClientId(user.value.clientId));

const selectedView = ref('prospective-students'); // Prospective / Existing students

const psView = reactive({
  type: 'create', // create or communicate winning features
  step: 2,
  yearDSE: 2026,
})

onMounted(async () => {
  const { homeSlideLink } = userRelatedClient.value;
  if (homeSlideLink) {
    CommonService.getSlideImageUrl(homeSlideLink).then(res => {
      clientHomeSlideImgUrl.value = res;
    })
  }
/*
  const loader = new Loader({
    apiKey: 'AIzaSyB2FELRC8eCvZx7kc5cFNpbY-RwYEPvH_8',
    version: 'weekly',
  });

  // Wait for Google Maps to load
  const google = await loader.load();
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

  // Your data
  const visitLocations = [
    { lat: 22.3193, lng: 114.1694, name: "Hong Kong Central", date: "2024-01-15" },
    { lat: 22.2829, lng: 114.1553, name: "Hong Kong Island", date: "2024-01-20" },
  ];

  // Initialize map
  loader.load().then(() => {
    const map = new google.maps.Map(document.getElementById('map'), {
      center: { lat: 22.3193, lng: 114.1694 },
      zoom: 11,
      mapId: 'SCHOOL_INPERSON_VISITS',
    });

    // Add markers with click handlers
    visitLocations.forEach(location => {
      const marker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: { lat: location.lat, lng: location.lng },
        title: location.name,
      });

      marker.addListener('click', () => {
        alert(`Clicked: ${location.name}`);
        // Your click handler here
      });
    });
  });*/
})


const groupedSessions = (targetAnchorEventId) => {
  const obj = {};
  for (const session of clientSessions.value) {
    let group = ""
    const { startTimeStr, anchorEventId, status } = session;
    if (anchorEventId != targetAnchorEventId) continue;
    if (status == "Rejected") continue;
    if (new Date(startTimeStr) > new Date(+new Date() - 86400000)) {
      group = "future";
    } else {
      group = "past";
    }
    obj[group] = obj[group] || [];
    obj[group].push(session);
  }
  return obj;
}

const groupedUniSessions = () => {
  const obj = {};
  for (const session of clientUniSessions.value) {
    let group = ""
    const { startTimeStr, anchorEventId, status } = session;
    if (status == "Rejected") continue
    if (new Date(startTimeStr) > new Date(+new Date() - 86400000)){
      group = "future"
    } else {
      group = "past"
    }
    if (anchorEventId == 'workshop2'){
      session.displayGroupName = "Educated job seeking"
    } else if (anchorEventId == 'cc31fb5c1') {
      session.displayGroupName = "Guest lecture"
    } else {
      session.displayGroupName = ""
    }

    obj[group] = obj[group] || [];
    obj[group].push(session);
  }
  return obj;
}
      

const openServiceModal = async (serviceId) => (await openModal(ServiceModal, { serviceId, isClientView: true, hideTeacherResponse: false }));

const openSessionStudentListModal = async (sessionId) => (await openModal(SessionStudentListModal, { sessionId }));

const openSessionUniStudentListModal = async (sessionId) => (await openModal(SessionStudentListModal, { sessionId, isStudentView: false, isShowUniStudents: true }));

const openSLPModal = async () => {
  const ev = store.getters.getLastAttendedSession;
  return await openModal(SLPModal, { ev, serviceId: ev?.serviceId, relatedProgramId: ev?.relatedProgramId, relatedClientId: user.value.clientId }, "", false)
}

const openUniEventDetails = async (sessionId) => (await openModal(UniEventsDetails, { sessionId }));

const openProposeDateModal = async () => (alert("Propose"));

const getClientPhotosByType = (type: any) => {
  const { clientPhotos } = userRelatedClient.value || {};
  return clientPhotos ? clientPhotos.filter(p => p.type == type) : [];
}

const openReportLink = () => {
  const currSelectedView = selectedView.value;
  window.open(userRelatedClient.value.longReportLink, '_blank');
  setTimeout(() => {
    selectedView.value = currSelectedView;
  }, 100)
}

return (_ctx: any,_cache: any) => {
  const _component_home_action_item = _resolveComponent("home-action-item")!

  return (loadingData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonSpinner))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (clientHomeSlideImgUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                style: {"width":"100%","cursor":"pointer"},
                src: clientHomeSlideImgUrl.value,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageModal)(clientHomeSlideImgUrl.value)))
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        (!user.value.isAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (userRelatedClient.value.workServiceId)
                ? (_openBlock(), _createBlock(_unref(IonCard), {
                    key: 0,
                    class: "outer-card"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonAccordionGroup), { value: "F5" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonAccordion), {
                            style: {"--min-height":"24px"},
                            value: "F5"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonItem), {
                                lines: "full",
                                slot: "header",
                                color: "fdmtred"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                      _createElementVNode("b", null, "4-hr workshop", -1)
                                    ])),
                                    _: 1,
                                    __: [9]
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonCard), { slot: "content" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonItem), {
                                    lines: "full",
                                    color: "light",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (openSLPModal())),
                                    button: "",
                                    detail: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                                            _createElementVNode("b", null, "SLP tool for students")
                                          ], -1)
                                        ])),
                                        _: 1,
                                        __: [10]
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(IonAccordionGroup), {
                                    multiple: true,
                                    value: ['coming']
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonAccordion), {
                                        value: "coming",
                                        key: "coming"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonItem), {
                                            slot: "header",
                                            color: "light"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                  _createElementVNode("p", { style: {"color":"#888888"} }, [
                                                    _createElementVNode("b", null, "Coming schedule")
                                                  ], -1)
                                                ])),
                                                _: 1,
                                                __: [11]
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createElementVNode("div", _hoisted_6, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedSessions('work-workshop-2')['future'], (session) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: session.id
                                              }, [
                                                _createVNode(_component_home_action_item, {
                                                  title: `${session.date} ${session.startTime} - ${session.status == 'TBC' ? 'Confirm' : session.status}`,
                                                  hideIcon: true,
                                                  onClick: ($event: any) => (session.status == 'Confirmed' ? openSessionStudentListModal(session.id) : openUniEventDetails(session.id)),
                                                  textColor: session.status == 'Confirmed' ? 'success' : 'danger'
                                                }, null, 8, ["title", "onClick", "textColor"])
                                              ]))
                                            }), 128)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientServices.value, (service) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: service.id
                                              }, [
                                                (service.nature == 'Workshop')
                                                  ? (_openBlock(), _createBlock(_component_home_action_item, {
                                                      key: 0,
                                                      title: `Workshop at university campus - Define date`,
                                                      hideIcon: true,
                                                      onClick: ($event: any) => (openServiceModal(service.id)),
                                                      textColor: 'danger'
                                                    }, null, 8, ["onClick"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(IonAccordion), {
                                        value: "past",
                                        key: "past"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonItem), {
                                            slot: "header",
                                            color: "light"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                  _createElementVNode("p", { style: {"color":"#888888"} }, [
                                                    _createElementVNode("b", null, "Past participation")
                                                  ], -1)
                                                ])),
                                                _: 1,
                                                __: [12]
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createElementVNode("div", _hoisted_7, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedSessions('work-workshop-2')['past'], (session) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: session.id
                                              }, [
                                                _createVNode(_component_home_action_item, {
                                                  title: `${session.date} ${session.startTime}`,
                                                  hideIcon: true,
                                                  onClick: ($event: any) => (openSessionStudentListModal(session.id))
                                                }, null, 8, ["title", "onClick"])
                                              ]))
                                            }), 128))
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(IonToolbar), { class: "sticky-toolbar" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSegment), {
                    class: "view-type-segment",
                    mode: "ios",
                    modelValue: selectedView.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedView).value = $event)),
                    scrollable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonSegmentButton), { value: "prospective-students" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("Prospective students")
                            ])),
                            _: 1,
                            __: [13]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonSegmentButton), { value: "existing-students" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode("Existing students")
                            ])),
                            _: 1,
                            __: [14]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonSegmentButton), {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (openReportLink()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode("Report")
                            ])),
                            _: 1,
                            __: [15]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (selectedView.value == 'existing-students')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (userRelatedClient.value.jobEXName)
                      ? (_openBlock(), _createBlock(_unref(IonCard), {
                          key: 0,
                          class: "outer-card"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonAccordionGroup), { value: "undergraduate" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonAccordion), {
                                  style: {"--min-height":"24px"},
                                  value: "undergraduate"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonItem), {
                                      lines: "full",
                                      slot: "header",
                                      color: "fdmtred"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonLabel), null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("b", null, _toDisplayString(userRelatedClient.value.department) + "-specific career training", 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonCard), { slot: "content" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonAccordionGroup), {
                                          multiple: true,
                                          value: ['coming']
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonAccordion), {
                                              value: "coming",
                                              key: "coming"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(IonItem), {
                                                  slot: "header",
                                                  color: "light"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                        _createElementVNode("p", { style: {"color":"#888888"} }, [
                                                          _createElementVNode("b", null, "Coming")
                                                        ], -1)
                                                      ])),
                                                      _: 1,
                                                      __: [16]
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createElementVNode("div", _hoisted_10, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedUniSessions()['future'], (session) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: session.id
                                                    }, [
                                                      _createVNode(_component_home_action_item, {
                                                        title: `${session.displayGroupName} [${session.date} ${session.startTime}] - ${session.status == 'TBC' ? 'Confirm' : session.status}`,
                                                        hideIcon: true,
                                                        onClick: ($event: any) => (openUniEventDetails(session.id)),
                                                        textColor: session.status == 'Confirmed' ? 'success' : 'danger'
                                                      }, null, 8, ["title", "onClick", "textColor"])
                                                    ]))
                                                  }), 128)),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientUniServices.value, (service) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: service.id
                                                    }, [
                                                      _createVNode(_component_home_action_item, {
                                                        title: `${service.name} - Define date`,
                                                        hideIcon: true,
                                                        onClick: ($event: any) => (openServiceModal(service.id)),
                                                        textColor: 'danger'
                                                      }, null, 8, ["title", "onClick"])
                                                    ]))
                                                  }), 128))
                                                ])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(IonAccordion), {
                                              value: "past",
                                              key: "past"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(IonItem), {
                                                  slot: "header",
                                                  color: "light"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                        _createElementVNode("p", { style: {"color":"#888888"} }, [
                                                          _createElementVNode("b", null, "Past")
                                                        ], -1)
                                                      ])),
                                                      _: 1,
                                                      __: [17]
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createElementVNode("div", _hoisted_11, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedUniSessions()['past'], (session) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: session.id
                                                    }, [
                                                      _createVNode(_component_home_action_item, {
                                                        title: `${session.displayGroupName} [${session.date} ${session.startTime}]`,
                                                        hideIcon: true,
                                                        onClick: ($event: any) => (openSessionUniStudentListModal(session.id))
                                                      }, null, 8, ["title", "onClick"])
                                                    ]))
                                                  }), 128))
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (userRelatedClient.value.id == 'caeb5730e')
                      ? (_openBlock(), _createBlock(_unref(IonCard), {
                          key: 0,
                          class: "outer-card"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonItem), {
                              lines: "full",
                              color: "fdmtred"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createElementVNode("b", null, "GIAWork", -1)
                                  ])),
                                  _: 1,
                                  __: [18]
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(IonToolbar), { class: "sticky-toolbar" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonSegment), {
                          class: "view-type-segment",
                          mode: "ios",
                          modelValue: psView.type,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((psView.type) = $event)),
                          scrollable: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonSegmentButton), { value: "create" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createElementVNode("b", null, "Create", -1),
                                    _createTextVNode("  "),
                                    _createElementVNode("small", null, "winning features", -1)
                                  ])),
                                  _: 1,
                                  __: [19]
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonSegmentButton), { value: "communicate" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                                    _createElementVNode("b", null, "Communicate", -1),
                                    _createTextVNode("  "),
                                    _createElementVNode("small", null, "winning features", -1)
                                  ])),
                                  _: 1,
                                  __: [20]
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_unref(IonToolbar), { class: "sticky-toolbar" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonSegment), {
                          class: "view-type-segment",
                          mode: "ios",
                          modelValue: psView.yearDSE,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((psView.yearDSE) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([2025, 2026, 2027], (year) => {
                              return _createVNode(_unref(IonSegmentButton), {
                                key: year,
                                value: year
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("DSE " + _toDisplayString(year), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, psView.type == 'communicate']
                    ]),
                    (psView.type == 'create')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_unref(IonRow), { class: "steps-container" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCol), { size: "auto" }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createElementVNode("div", { class: "step" }, [
                                    _createElementVNode("div", { class: "step-content" }, "1. Competing programs")
                                  ], -1)
                                ])),
                                _: 1,
                                __: [21]
                              }),
                              _createVNode(_unref(IonCol), {
                                size: "auto",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (psView.step = 2))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(['step', psView.step == 2 ? 'active' : ''])
                                  }, _cache[22] || (_cache[22] = [
                                    _createElementVNode("div", { class: "step-content" }, "2. Pre-campaign interest", -1)
                                  ]), 2)
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonCol), {
                                size: "auto",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (psView.step = 3))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(['step', psView.step == 3 ? 'active' : ''])
                                  }, _cache[23] || (_cache[23] = [
                                    _createElementVNode("div", { class: "step-content" }, "3. Winning features", -1)
                                  ]), 2)
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonCol), { size: "auto" }, {
                                default: _withCtx(() => _cache[24] || (_cache[24] = [
                                  _createElementVNode("div", { class: "step" }, [
                                    _createElementVNode("div", { class: "step-content" }, "4. Hypothetical program")
                                  ], -1)
                                ])),
                                _: 1,
                                __: [24]
                              }),
                              _createVNode(_unref(IonCol), { size: "auto" }, {
                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                  _createElementVNode("div", { class: "step" }, [
                                    _createElementVNode("div", { class: "step-content" }, "5. Video script")
                                  ], -1)
                                ])),
                                _: 1,
                                __: [25]
                              }),
                              _createVNode(_unref(IonCol), {
                                size: "auto",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (psView.step = 6))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(['step', psView.step == 6 ? 'active' : ''])
                                  }, _cache[26] || (_cache[26] = [
                                    _createElementVNode("div", { class: "step-content" }, "6. Video", -1)
                                  ]), 2)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (psView.step == 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[27] || (_cache[27] = [
                                _createElementVNode("div", { class: "step-label" }, "Nursing", -1)
                              ])))
                            : _createCommentVNode("", true),
                          (psView.step == 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[28] || (_cache[28] = [
                                _createElementVNode("div", { class: "step-label" }, "Global Nursing Leader Distinction", -1)
                              ])))
                            : _createCommentVNode("", true),
                          (psView.step == 6)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[29] || (_cache[29] = [
                                _createElementVNode("div", { class: "step-label ion-text-center" }, [
                                  _createElementVNode("iframe", {
                                    style: {"width":"80%","height":"380px"},
                                    src: "https://www.youtube.com/embed/D0Uygm6D758",
                                    frameborder: "0",
                                    allowfullscreen: ""
                                  })
                                ], -1)
                              ])))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _cache[39] || (_cache[39] = _createStaticVNode("<table class=\"advertisement-table\" data-v-9470ce6a><tbody data-v-9470ce6a><tr data-v-9470ce6a><td style=\"padding-left:12px;\" data-v-9470ce6a><span class=\"large-text\" data-v-9470ce6a>Band 1A-2A schools</span><br data-v-9470ce6a><small data-v-9470ce6a>with WhatsApp-connected principals, teachers &amp; students</small></td><td style=\"padding-left:16px;padding-right:0;\" data-v-9470ce6a><span class=\"large-text\" data-v-9470ce6a>133</span> / ~200<br data-v-9470ce6a><small data-v-9470ce6a>(~70%)</small></td></tr></tbody></table><table class=\"advertisement-table\" data-v-9470ce6a><thead data-v-9470ce6a><tr data-v-9470ce6a><th style=\"background-color:#027DCA;\" data-v-9470ce6a>Students&#39; reach</th></tr></thead></table>", 2)),
                            _createVNode(ActionAccordionGroup, {
                              "no-accordion": false,
                              "header-color": 'primary',
                              "no-padding": true
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_unref(IonItem), {
                                  lines: "full",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                                        _createTextVNode("Assembly video sharing, WhatsApp survey"),
                                        _createElementVNode("br", null, null, -1),
                                        _createElementVNode("span", { class: "small-text" }, "enabled by school-signed MOUs", -1)
                                      ])),
                                      _: 1,
                                      __: [30]
                                    }),
                                    _createVNode(_unref(IonLabel), {
                                      slot: "end",
                                      class: "large-text"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(psView.yearDSE == 2027 ? 0 : 2112), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: psView.yearDSE == 2027 ? require('@/assets/sn4.jpeg') : require('@/assets/sn3.jpeg')
                                }, null, 8, _hoisted_19)
                              ]),
                              _: 1
                            }),
                            _createVNode(ActionAccordionGroup, {
                              "no-accordion": false,
                              "header-color": 'primary',
                              "no-padding": true
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_unref(IonItem), {
                                  lines: "full",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                                        _createTextVNode("University visit, school visit, Zoom"),
                                        _createElementVNode("br", null, null, -1),
                                        _createElementVNode("span", { class: "small-text" }, "arranged voluntarily by teachers", -1)
                                      ])),
                                      _: 1,
                                      __: [31]
                                    }),
                                    _createVNode(_unref(IonLabel), {
                                      slot: "end",
                                      class: "large-text"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(psView.yearDSE == 2027 ? 0 : 14), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                (psView.yearDSE == 2026)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: require('@/assets/sn2.jpeg')
                                    }, null, 8, _hoisted_20))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(ActionAccordionGroup, {
                              "no-accordion": false,
                              "header-color": 'primary',
                              "no-padding": true
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_unref(IonItem), {
                                  lines: "full",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                                        _createTextVNode("University workshop, visit"),
                                        _createElementVNode("br", null, null, -1),
                                        _createElementVNode("span", { class: "small-text" }, "Enrolled voluntarily by students", -1)
                                      ])),
                                      _: 1,
                                      __: [32]
                                    }),
                                    _createVNode(_unref(IonLabel), {
                                      slot: "end",
                                      class: "large-text"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(psView.yearDSE == 2027 ? 0 : 42), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: psView.yearDSE == 2027 ? require('@/assets/sn5.jpeg') : require('@/assets/sn1.jpeg')
                                }, null, 8, _hoisted_21)
                              ]),
                              _: 1
                            }),
                            _cache[40] || (_cache[40] = _createElementVNode("table", { class: "advertisement-table" }, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { style: {"background-color":"#027DCA"} }, "Students’ choices in pre-JUPAS school counselling")
                                ])
                              ])
                            ], -1)),
                            _createVNode(ActionAccordionGroup, {
                              "no-accordion": false,
                              "header-color": 'fdmtred',
                              "no-padding": true
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_unref(IonItem), {
                                  lines: "full",
                                  color: "fdmtred"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                                        _createElementVNode("span", { class: "large-text" }, "JS3648 PolyU", -1),
                                        _createElementVNode("br", null, null, -1),
                                        _createElementVNode("span", { class: "small-text" }, "Bachelor of Science (Honours) in Nursing", -1)
                                      ])),
                                      _: 1,
                                      __: [33]
                                    }),
                                    _createVNode(_unref(IonLabel), {
                                      slot: "end",
                                      class: "ion-text-right"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_22, _toDisplayString(psView.yearDSE == 2027 ? 0 : 46), 1),
                                        _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                                        _cache[35] || (_cache[35] = _createElementVNode("small", null, "A1-B3", -1))
                                      ]),
                                      _: 1,
                                      __: [34,35]
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(ActionAccordionGroup, {
                              "no-accordion": false,
                              "header-color": 'fdmtred',
                              "no-padding": true
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_unref(IonItem), {
                                  lines: "full",
                                  color: "fdmtred"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => _cache[36] || (_cache[36] = [
                                        _createElementVNode("span", { class: "large-text" }, "JS3337 PolyU", -1),
                                        _createElementVNode("br", null, null, -1),
                                        _createElementVNode("span", { class: "small-text" }, "Bachelor of Science (Honours) in Mental Health Nursing", -1)
                                      ])),
                                      _: 1,
                                      __: [36]
                                    }),
                                    _createVNode(_unref(IonLabel), {
                                      slot: "end",
                                      class: "ion-text-right"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_23, _toDisplayString(psView.yearDSE == 2027 ? 2 : 33), 1),
                                        _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                                        _cache[38] || (_cache[38] = _createElementVNode("small", null, "A1-B3", -1))
                                      ]),
                                      _: 1,
                                      __: [37,38]
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
                          _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                          _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
                          _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
                          _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1)),
                          _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
                          _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
                          _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
                          false
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _cache[42] || (_cache[42] = _createStaticVNode("<div class=\"table-container\" data-v-9470ce6a><table class=\"advertisement-table\" data-v-9470ce6a><thead data-v-9470ce6a><tr data-v-9470ce6a><th data-v-9470ce6a>Advertisement</th><th data-v-9470ce6a></th><th data-v-9470ce6a>Click <small data-v-9470ce6a>(since 2024 Sep)</small></th><th data-v-9470ce6a>Circulation</th></tr></thead><tbody data-v-9470ce6a><tr data-v-9470ce6a><td data-v-9470ce6a>2024 Nov 18</td><td data-v-9470ce6a>Nursing<br data-v-9470ce6a>Healthcare</td><td class=\"highlight-cell\" data-v-9470ce6a>25<br data-v-9470ce6a>30</td><td data-v-9470ce6a>1000<br data-v-9470ce6a>-</td></tr></tbody></table></div><div class=\"table-container\" data-v-9470ce6a><table class=\"advertisement-table\" data-v-9470ce6a><thead data-v-9470ce6a><tr data-v-9470ce6a><th data-v-9470ce6a>Promotional survey</th><th data-v-9470ce6a></th><th data-v-9470ce6a>Responses</th><th data-v-9470ce6a></th></tr></thead><tbody data-v-9470ce6a><tr data-v-9470ce6a><td data-v-9470ce6a>2024 Sep 13 (F5)</td><td class=\"ion-text-right\" data-v-9470ce6a>XX Will: X<br data-v-9470ce6a>Will not: Y</td><td class=\"highlight-cell\" data-v-9470ce6a>85</td><td data-v-9470ce6a>1000</td></tr></tbody></table></div>", 2)),
                                _createElementVNode("div", _hoisted_25, [
                                  _cache[41] || (_cache[41] = _createElementVNode("table", { class: "advertisement-table" }, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Video shooting")
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("td", null, "2024 Sep 30 (F5)")
                                      ])
                                    ])
                                  ], -1)),
                                  (getClientPhotosByType('Shooting').length > 0)
                                    ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getClientPhotosByType('Shooting'), (p, idx) => {
                                            return (_openBlock(), _createBlock(_unref(IonCol), { key: idx }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  style: {"cursor":"pointer"},
                                                  src: p.photoLink,
                                                  onClick: ($event: any) => (_unref(openImageModal)(p.photoLink))
                                                }, null, 8, _hoisted_26)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _cache[43] || (_cache[43] = _createStaticVNode("<div class=\"table-container\" data-v-9470ce6a><table class=\"advertisement-table\" data-v-9470ce6a><thead data-v-9470ce6a><tr data-v-9470ce6a><th data-v-9470ce6a>In-person visits</th></tr></thead></table><div id=\"map\" style=\"height:400px;width:100%;\" data-v-9470ce6a></div></div><div class=\"table-container\" data-v-9470ce6a><table class=\"advertisement-table\" data-v-9470ce6a><thead data-v-9470ce6a><tr data-v-9470ce6a><th data-v-9470ce6a>2-hr visit</th><th data-v-9470ce6a>Participants</th></tr></thead><tbody data-v-9470ce6a><tr data-v-9470ce6a><td data-v-9470ce6a>2026 Feb X</td><td data-v-9470ce6a>TBC</td></tr><tr data-v-9470ce6a><td data-v-9470ce6a>2025 Sep X</td><td data-v-9470ce6a>TBC</td></tr><tr data-v-9470ce6a><td data-v-9470ce6a>2025 Jan 20</td><td data-v-9470ce6a>27</td></tr><tr data-v-9470ce6a><td data-v-9470ce6a>2024 Sep 30</td><td data-v-9470ce6a>25</td></tr></tbody></table></div><div class=\"table-container\" data-v-9470ce6a><table class=\"advertisement-table\" data-v-9470ce6a><thead data-v-9470ce6a><tr data-v-9470ce6a><th data-v-9470ce6a>4-hr workshop</th><th data-v-9470ce6a>Participants</th></tr></thead><tbody data-v-9470ce6a><tr data-v-9470ce6a><td data-v-9470ce6a>2025 Jun 27</td><td data-v-9470ce6a>35</td></tr></tbody></table></div>", 3))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ]))
            ]))
      ]))
}
}

})